import { Mail } from "lucide-react";
import { Link } from "react-router";

const Footer = () => {
    return (
        <footer className="bg-white border-t border-border/50">
            <div className="max-w-6xl mx-auto px-4 lg:px-8 py-8">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
                    <div className="flex flex-col col-span-2 md:mr-24">
                        <Link to="/" className="flex items-center mb-2">
                            <img
                                src="/logo.png"
                                alt="Bluesky Insights"
                                width={32}
                                height={32}
                            />
                            <span className="ml-1 text-lg font-semibold">
                                <span className="text-primary">Bluesky</span>{" "}
                                <span className="text-primary">Insights</span>
                            </span>
                        </Link>
                        <p className="text-sm text-muted-foreground">
                            The ultimate platform for free Bluesky analytics,
                            helping you analyze and grow your presence.
                        </p>
                        <a
                            href="https://www.buymeacoffee.com/sahajjain1z"
                            target="_blank"
                            className="mt-8 md:mt-12"
                        >
                            <img
                                src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png"
                                alt="Buy Me A Coffee"
                                className="h-[30px] w-[107px]"
                            />
                        </a>
                    </div>

                    <div className="flex flex-col w-fit">
                        <h3 className="font-medium text-xs mb-2">Connect</h3>
                        <a
                            href="https://bsky.app/profile/bskyinsights.com"
                            className="flex items-center text-sm text-muted-foreground mb-2 bg-[#1185fe] px-2 py-1 rounded text-white font-semibold"
                        >
                            <img
                                src="/bluesky-logo-white.svg"
                                alt="Bluesky"
                                className="mr-2 w-4"
                            />
                            Follow <span className="hidden md:inline">&nbsp;on Bluesky</span>
                        </a>
                        <a
                            href="mailto:sahajjain13@gmail.com"
                            className="flex items-center text-sm text-muted-foreground hover:underline mb-2"
                        >
                            <Mail
                                fill="hsl(var(--muted-foreground))"
                                stroke="white"
                                className="mr-2 w-4"
                            />
                            Contact
                        </a>
                    </div>

                    <div className="flex flex-col w-fit">
                        <h3 className="font-medium text-xs mb-2">
                            Quick Links
                        </h3>
                        <Link
                            to="/about"
                            className=" text-sm text-muted-foreground hover:underline mb-2"
                        >
                            About
                        </Link>
                        <Link
                            to="/privacy-policy"
                            className="text-sm text-muted-foreground hover:underline mb-2"
                        >
                            Privacy Policy
                        </Link>
                        <Link
                            to="/terms-of-service"
                            className="text-sm text-muted-foreground hover:underline mb-2"
                        >
                            Terms of Service
                        </Link>
                        <Link
                            to="/refund-policy"
                            className="text-sm text-muted-foreground hover:underline mb-2"
                        >
                            Refund Policy
                        </Link>
                        <Link
                            to={import.meta.env.VITE_POSTHOG_LINK}
                            className="text-sm text-muted-foreground hover:underline mb-2
              flex items-center gap-2"
                        >
                            Web Analytics
                            <img
                                src="https://posthog.com/brand/posthog-logomark.png"
                                alt="posthog logo"
                                className="w-5"
                            />
                        </Link>
                    </div>
                </div>

                <div className="mt-8 pt-4 border-t border-border/50 text-center text-sm text-muted-foreground">
                    © {new Date().getFullYear()} Bluesky Insights by&nbsp;
                    <a
                        href="https://bsky.app/profile/iamsahaj.xyz"
                        className="hover:underline"
                    >
                        @iamsahaj.xyz
                    </a>
                    . All rights reserved.
                </div>
            </div>
        </footer>
    );
};

export default Footer;
